import { defineMessages } from "react-intl"

export const porscheApprovedMessages = defineMessages({
	certified: {
		defaultMessage: "Certified",
		id: "porscheApproved.certified",
	},
	dateRange: {
		defaultMessage: "{startDate} to {endDate}",
		id: "porscheApproved.dateRange",
	},
	formerSelectionInvalid: {
		defaultMessage: "Your former selection is no longer valid.",
		id: "porscheApproved.selectionNoLongerValid",
	},
	invalidSaleLabel: {
		defaultMessage: "The sale is invalid. Please cancel the sale and recreate it.",
		id: "porscheApproved.dealerShouldCancelAndRecreateInvalidSale",
	},
	minimumMarketWarrantyPeriodCoveredMessage: {
		defaultMessage: "The minimum warranty period of {minimumWarrantyPeriod} months is covered.",
		id: "porscheApproved.minimumWarrantyPeriodCovered",
	},
	minimumMarketWarrantyPeriodNotCoveredMessage: {
		defaultMessage: "The minimum warranty period of {minimumWarrantyPeriod} months is not covered.",
		id: "porscheApproved.minimumWarrantyPeriodNotCovered",
	},
	newCarWarranty: {
		defaultMessage: "New Car Warranty",
		id: "porscheApproved.newCarWarranty",
	},
	notCertified: {
		defaultMessage: "Not certified",
		id: "porscheApproved.notCertified",
	},
	porscheApproved: {
		defaultMessage: "Porsche Approved",
		id: "porscheApproved.porscheApprovedUsedCarWarranties",
	},
	porscheApprovedCertifiedNotAvailable: {
		defaultMessage: "This vehicle cannot be Porsche Approved certified.",
		id: "porscheApproved.certifiedNotAvailable",
	},
	remainingMonths: {
		defaultMessage: "{remainingWarranty, plural, one {# month} other {# months}}",
		id: "porscheApproved.remainingMonths",
	},
	remainingWarranty: {
		defaultMessage: "Remaining warranty",
		id: "porscheApproved.remainingWarranty",
	},
	status: {
		defaultMessage: "Status",
		id: "porscheApproved.status",
	},
	unexpectedError: {
		defaultMessage: "Unable to report warranty. Please try again later.",
		id: "porscheApproved.unexpectedError",
	},
	unknownError: {
		defaultMessage: "Oops, something went wrong.",
		id: "porscheApproved.unknownError",
	},
	updatePorscheApprovedUnexpectedError: {
		defaultMessage: "Unable to save whether the vehicle is Porsche Approved. Please try again later.",
		id: "porscheApproved.updatePorscheApprovedUnexpectedError",
	},
	violationReasonDerivativeNotAllowed: {
		defaultMessage: "This derivative cannot be Porsche Approved certified.",
		id: "porscheApproved.violationReasonDerivativeNotAllowed",
	},
	violationReasonIsNewCar: {
		defaultMessage: "The vehicle is classified as a new car.",
		id: "porscheApproved.violationReasonIsNewCar",
	},
	violationReasonMandatoryButNotPossible: {
		defaultMessage: "Vehicle has non-active CPO Warranty attached.",
		id: "porscheApproved.violationReasonFutureCpo",
	},
	violationReasonMileageLimitExceeded: {
		defaultMessage: "The mileage limit has been exceeded.",
		id: "porscheApproved.violationReasonMileageLimitExceeded",
	},
	violationReasonModelSeriesNotAllowed: {
		defaultMessage: "This model series cannot be Porsche Approved certified.",
		id: "porscheApproved.violationReasonModelSeriesNotAllowed",
	},
	violationReasonNewMarketMinimumWarrantyRuntimeExceedsVehicleAge: {
		defaultMessage: "The market's minimum warranty runtime would exceed the maximum possible coverage period.",
		id: "porscheApproved.violationReasonNewMarketMinimumWarrantyRuntimeExceedsVehicleAge",
	},
	violationReasonResidualWarrantyInsufficientForMarketMinimumStandard: {
		defaultMessage: "The residual warranty is insufficient for the market's minimum standard.",
		id: "porscheApproved.violationReasonResidualWarrantyInsufficientForMarketMinimumStandard",
	},
	violationReasonResidualWarrantyIsNotConsideredInThisMarket: {
		defaultMessage: "The residual warranty is not considered in this market.",
		id: "porscheApproved.violationReasonResidualWarrantyIsNotConsideredInThisMarket",
	},
	violationReasonsLabel: {
		defaultMessage: "The vehicle cannot be Porsche Approved certified for the following reasons:",
		id: "porscheApproved.violationReasonsLabel",
	},
	violationReasonUsedCarWarrantyProductNotAvailableInMarket: {
		defaultMessage: "The Porsche Approved Used Car Warranty is not available in this market.",
		id: "porscheApproved.violationReasonUsedCarWarrantyProductNotAvailableInMarket",
	},
	violationReasonVehicleNotHomologatedInMarket: {
		defaultMessage: "The vehicle is not homologated in this market.",
		id: "porscheApproved.violationReasonVehicleNotHomologatedInMarket",
	},
	violationReasonWarrantyOptionRuntimeExceedsVehicleAge: {
		defaultMessage: "The warranty option runtime would exceed the maximum possible coverage period.",
		id: "porscheApproved.violationReasonWarrantyOptionRuntimeExceedsVehicleAge",
	},
	violationReasonWarrantyRequired: {
		defaultMessage: "A warranty is required.",
		id: "porscheApproved.violationReasonWarrantyRequired",
	},
	warrantyLabel: {
		defaultMessage: "Porsche Approved",
		id: "porscheApproved.warrantyLabel",
	},
	warrantyOptionDisablementReasonsLabel: {
		defaultMessage: "The option cannot be selected for the following reasons:",
		id: "porscheApproved.warrantyOptionDisablementReasonsLabel",
	},
	warrantyReportingNotNecessary: {
		defaultMessage: "Reporting a warranty is not necessary.",
		id: "porscheApproved.reportingNotNecessary",
	},
	warrantySelectionCancelDeliveryNecessary: {
		defaultMessage:
			"You have already reported a warranty in the delivery process. If you want to change the warranty you need to cancel the sale first.",
		id: "porscheApproved.warrantySelectionCancelDeliveryNecessary",
	},
	warrantyServiceNotAvailable: {
		defaultMessage: "Warranty Service not available. Please try again later.",
		id: "porscheApproved.warrantyServiceNotAvailable",
	},
	warrantyWillBeReported: {
		defaultMessage: "A warranty of {warrantyPeriod} months will be reported.",
		id: "porscheApproved.willBeReported",
	},
})
